import React from 'react';
import '../Aboutschool/AboutschoolCard.css';

const AboutschoolCard = (props) => {
  return (
    <div className="afounder_box card flex-fill">
      {/* Image on top */}
      <img src={props.image} className="card-img-top img-fluid big-image" alt={props.header} />

      {/* Text below image */}
      <div className="card-body acaptions">
        <h3 className="card-title">{props.header}</h3>
        <p className="card-text apara">{props.descr1}</p>
        <p className="card-text apara">{props.descr2}</p>
        {/* <button className="btn btn-primary afbtn">Read more...</button> */}
        
        {props.header === "ABOUT SCHOOL" && (
        <a href="/aboutus"><button>Read more...</button></a>
        )}

        {props.header === "AIMS & OBJECTIVES" && (
        <a href="/chooseus"><button>Read more...</button></a>
        )}
        
      </div>
    </div>
  );
};

export default AboutschoolCard;